export const get_security_transfers = `query get_security_transfers($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_security_transfers(paginator: $paginator, order: $order, filter: $filter){
        security_transfers{
            transaction_code
            status
            account
            security{
                short_name
                name
                stock_market_locality
                currency{
                    currency
                    name
                    decimal
                }
            }
            amount
            order_date
        }
        page
        page_count
    }
}`;
